import React from "react";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useRecipes from "../../../hooks/useRecipes";
import MealPlanDetails from "./recipes/MealPlanDetails";

const MealPlanDetailPage = () => {
  const { orgId, mealPlanId } = useParams();
  const organizationId = orgId;
  const navigate = useNavigate();
  const { mealPlans, getRecipesFromList } = useRecipes({ organizationId });

  const mealPlan = mealPlans.find((m) => m.id === mealPlanId);

  return (
    <Box
      sx={{
        margin: 1,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        px: { xs: 2, sm: 3 },
      }}
    >
      <Box sx={{ mt: 2.5 }}>
        <Breadcrumbs separator=">">
          <Link
            onClick={() => {
              window.scrollTo(0, 0);
              navigate("/home/recipes");
            }}
            style={{ cursor: "pointer" }}
          >
            Meal Plans
          </Link>
          <Typography>{mealPlan?.name || "Unknown Meal Plan"}</Typography>
        </Breadcrumbs>

        <Box style={{ marginTop: 20 }}>
          {mealPlans.length === 0 ? (
            <Typography>Loading meal plans...</Typography>
          ) : (
            <MealPlanDetails
              mealPlan={mealPlan}
              getRecipesFromList={getRecipesFromList}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MealPlanDetailPage;
